export default "__VITE_ASSET__C1CAy5nn__"